import CreateStudentModal from "../../../Students/CreateStudentModal";

// Thin shim kept so existing quote-flow imports keep working.
export default function CreateNewStudentModal(props) {
  return <CreateStudentModal {...props} />;
}
